import { Address, CustomerUserError } from 'shopify-types'

import { GlobalRequestOptions } from '@/shopify/types'

import { storefrontClient } from '../..'
import { GQL_ADDRESS_FRAGMENT, mapGQLAddressToAddress } from './graphql'

type UpdateAddressResponse = Readonly<{
  customerAddressUpdate: {
    customerAddress: Address
    customerUserErrors: CustomerUserError[]
  }
}>

export const updateAddress =
  (options: GlobalRequestOptions) => async (token: string, address: Address) => {
    const response = await storefrontClient.request<UpdateAddressResponse>(
      `#graphql
      mutation customerAddressUpdate($address: MailingAddressInput!, $customerAccessToken: String!, $id: ID!, $language: LanguageCode) @inContext(language: $language) {
        customerAddressUpdate(address: $address, customerAccessToken: $customerAccessToken, id: $id) {
          customerAddress {
            ${GQL_ADDRESS_FRAGMENT}
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `,
      {
        variables: {
          id: address.id,
          address: { ...address, id: undefined },
          customerAccessToken: token,
          language: options.language,
        },
      },
    )

    if (!response.data?.customerAddressUpdate.customerAddress) {
      throw new Error('Failed to update address')
    }

    return mapGQLAddressToAddress(response.data?.customerAddressUpdate.customerAddress)
  }
